import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AUTH } from '@/constants/testIds';

export default function Register() {
  const nav = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [organization, setOrganization] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register({ name, email, password, organization, role: 'analyst' });
      toast.success('Cuenta creada');
      nav('/');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al registrar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-slate-50">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-slate-200 p-8">
        <div className="label-caps">StrategIA</div>
        <h2 className="font-display text-3xl font-bold mt-2 mb-6 tracking-tight">Crear cuenta de analista</h2>

        <div className="space-y-4">
          <div>
            <Label>Nombre completo</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} data-testid={AUTH.nameInput} required className="mt-1" />
          </div>
          <div>
            <Label>Empresa</Label>
            <Input value={organization} onChange={(e) => setOrganization(e.target.value)} className="mt-1" />
          </div>
          <div>
            <Label>Correo</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid={AUTH.emailInput} required className="mt-1" />
          </div>
          <div>
            <Label>Contraseña</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid={AUTH.passwordInput} required className="mt-1" />
          </div>
        </div>

        <Button type="submit" disabled={loading} data-testid={AUTH.submitBtn}
                className="w-full mt-6 bg-blue-900 hover:bg-blue-800 h-11 font-semibold">
          {loading ? 'Creando…' : 'Crear cuenta'}
        </Button>

        <div className="mt-6 text-sm text-slate-600">
          ¿Ya tienes cuenta?{' '}
          <Link to="/login" data-testid={AUTH.toLogin} className="text-blue-900 font-semibold hover:underline">
            Iniciar sesión
          </Link>
        </div>
      </form>
    </div>
  );
}
